<div class="modal-container main-font">
  <div class="content-container w-100">
    <div class="title-container">
      <p class="mb-0 text-title">Sei sicuro di voler rifiutare la richiesta?</p>
    </div>
    <app-alert
      class="w-100"
      [message]="
        'Per rifiutare una richiesta è necessaria una motivazione'
      "></app-alert>
    <textarea
      nz-input
      [(ngModel)]="motivation"
      placeholder="Inserisci una motivazione"
      [nzAutosize]="{ minRows: 4, maxRows: 4 }"></textarea>
  </div>
  <div class="d-flex gap-2 align-items-center flex-nowrap w-100">
    <button class="primary-btn-outline-new w-100" (click)="closeModal()">
      Annulla
    </button>
    <button
      class="secondary-btn-new w-100"
      [disabled]="motivation.trim().length == 0"
      (click)="confirm()">
      Rifiuta
    </button>
  </div>
</div>
